import { render } from "./SectionHeader.vue?vue&type=template&id=a6699cca&lang=pug"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=a6699cca&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__